<template>
    <CollapsibleWidget v-if="options.length > 0">
        <template #name>Master Template Type</template>

        <template #controls />

        <CheckboxGroup v-model="masterTemplatesLibraryStore.types" class="editable-group__values" :vertical="true">
            <Checkbox v-for="option in options" :key="option" :label="option" :disabled="isUsedInCampaign" />
        </CheckboxGroup>
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";
import { TemplateType } from "shared-utils/enums/masterTemplate";

const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();

const { isUsedInCampaign } = defineProps<{
    isUsedInCampaign?: boolean;
}>();

const options = Object.values(TemplateType);
</script>

<style lang="scss">
.editable-group {
    .show-form--showing {
        display: none;
    }
}

.editable-group__add {
    width: 100%;
}

.editable-group__values {
    width: 100%;
}
</style>
